import type { BlogPost } from "~/types";

export default function useStore() {
  const blogPost = useState<BlogPost | null>(() => null);

  return {
    blogPost
  };
}